// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import { TYPE } from '../../../constants/targetConstants';
import { targetSelector } from '../../../selectors/appSelectors';
import { headingComputedSelector, headingSelector, speedComputedSelector, speedSelector } from '../../../selectors/targetSelectors';
import { makeCarEntityAutoSelector, callsignSelector as carCallsignSelector } from '../../../selectors/carSelectors';
import { makePlaneEntitySelector, callsignSelector as planeCallsignSelector } from '../../../selectors/planeSelectors';
import { vehicleUserIdSelector } from '../../../selectors/vehicleSelectors';
import { makeUserEntitySelector } from '../../../selectors/usersSelectors';
import TargetInspector from '../TargetInspector';
import type { Props } from '../TargetInspector';

const mapStateToProps = (state: State) => {
    const targetData = targetSelector(state);

    let target;
    let callsign;
    let headingComputed;
    let heading;
    let speedComputed;
    let speed;
    let operator;
    if(targetData) {
        let targetBuffer;
        if(targetData.type === TYPE.car) {
            targetBuffer = makeCarEntityAutoSelector(targetData.id)(state);
            target = targetBuffer && targetBuffer[0];
            callsign = carCallsignSelector(targetData.id, targetBuffer)(state);

        }
        else if(targetData.type === TYPE.plane) {
            targetBuffer = makePlaneEntitySelector(targetData.id)(state);
            target = targetBuffer && targetBuffer[0];
            callsign = planeCallsignSelector(targetData.id, targetBuffer)(state);
        }
        else {
            throw new Error(`Unknown target type "${targetData.type}"`);
        }

        headingComputed = headingComputedSelector(targetBuffer)(state);
        heading = headingSelector(targetData.id, targetBuffer)(state);
        speedComputed = speedComputedSelector(targetBuffer)(state);
        speed = speedSelector(targetData.id, targetBuffer)(state);

        const userId = vehicleUserIdSelector(targetData.id)(state);
        operator = userId && makeUserEntitySelector(userId)(state);
    }

    return {
        target,
        callsign,
        headingComputed,
        heading,
        speedComputed,
        speed,
        operator
    };
};

export default connect<Props, _, _, _, _, _>(mapStateToProps)(TargetInspector);